import React, { useEffect, useState } from 'react';

import Login from './login/hoa-login';
import Loading from './loading/hoa-loading';
import SplashPhoto from './splash-photo/hoa-splash-photo';
import ErrorMessage from './error-message/hoa-error-message';

//Context
import { GlobalContext } from '../context/hoa-global-context';

//controller
import useLoadingController from '../controller/hoa-loading-controller';

//Component
import Layout from './layout/hoa-layout';

import datastore from '../store/hoa-datastore';
import UrlParamsService from '../services/hoa-url-params-service';

import config from '../hoa-config';
import dashboardService from '../services/hoa-dashboard-api-service';
import OrganizationSelection from '../Container/organization-selection';
import dashboardServices from '../services/hoa-dashboard-api-service';

import { mappingNotVisibleKeys } from "../utility/data-configurator-helper";

interface AppState {
    loadingProgress: number;
    accessCheckComplete: boolean;
    unauthorized: boolean;
    forbidden: boolean;
    error:any;
    drawerOpen:boolean;
    selectedOrganization: any;
}


export default function App() {

    const [state, setState] = useState<AppState>({
        loadingProgress: 0,
        accessCheckComplete: false,
        unauthorized: undefined,
        forbidden: undefined,
        error:null,
        drawerOpen:true,
        selectedOrganization: undefined
    });

    const [activeMenu, setActiveMenu] = useState('');
    const [activeTab, setActiveTab] = useState(-1);

    const [muncipality,setMuncipality] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [property,setProperty] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [hoa,setHoa] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        inactiveHoaCount: null,
        options:{}
    })

    const [email,setEmail] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [dataFieldConfigurator,setDataFieldConfigurator] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [mail,setMail] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [requests, setRequests] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [document, setDocument] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [triggerNotifications, setTriggerNotifications] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [triggerNotificationLogs, setTriggerNotificationLogs] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [pendingSource, setPendingSource] = useState({
        data:[],
        count: null,
        pageNumber:1,
        isLastPage:false,
        fetchingFilteredData:false,
        options:{}
    })

    const [selectedHoaDocuments, setSelectedHoaDocuments] = useState({});

    const [amenitiesDocImage, setAmenitiesDocImage] = useState({});

    const [hoaDocumentToBeDeleted, setHoaDocumentToBeDeleted] = useState({});

    const [violationStructureBuildingFiles, setViolationStructureBuildingFiles] = useState({});
    
    const [viewMoreDetails, setViewMoreDetails] = useState({})

    const [view, setView] = useState('list')

    const [selectedValues, setSelectedValues]:any = useState({})

    const [selectedDataFieldConfigurator,setSelectedDataFieldConfigurator]:any =useState({})

    const { checkAccessRights, getUserDataInformation, checkUserRole, checkWhichOrgUser } = useLoadingController();

    const getActiveMenu = () => {
        var menu = UrlParamsService.urlParams.menu;
        var validMenuUrlParams = config.validMenuUrlParams;
        var clientValidMenuUrlParams = config.clientValidMenuUrlParams;

        if(datastore.userRole === config.userRoles.OrganizationUser && !menu) {
            menu = "hoas";
        }
        if(datastore.userRole === config.userRoles.OrganizationUser && (clientValidMenuUrlParams.findIndex((item: string) => item.toLowerCase() == menu.toLowerCase()) < 0)) {
            menu = "hoas";
        }

        if(!menu || (validMenuUrlParams.findIndex((item: string) => item.toLowerCase() == menu.toLowerCase()) < 0)) {
            menu = "Municipalities";
        }

        menu = menu.toLowerCase();

        if(menu == "hoa" || menu == "mail"
            || menu == "request" || menu == "document") {

            menu += "s";
        }
        else if(menu == "municipality" || menu == "property") {
            menu = menu.substring(0, menu.length - 1) + "ies";
        }

        return menu;
    }

    const getActiveTab = (menu: string, activeId: string) => {
        var activeTab = UrlParamsService.urlParams.tab;
        var activeTabIndex = -1;

        if(activeTab) {
            let tabTitles = [];
            
            if(menu.toLowerCase() == "hoas") {
                tabTitles = config.hoaTabTitles;  
            }
            else if(menu.toLowerCase() == "municipalities") {
                tabTitles = config.municipalityTabTitles;
            }
            else if(menu.toLowerCase() == "properties") {
                tabTitles = config.propertyTabTitles;
            }
            else if(menu.toLowerCase() == "webhook") {
                tabTitles = config.webhookTabTitles;
            }

            activeTabIndex = tabTitles.findIndex((tab:string) => {
                return tab.replace(/\s/g, '').toLowerCase() === activeTab.toLowerCase();
            });
        }

        if(activeTabIndex == -1 && menu && (activeId || menu === "webhook")) {
            activeTabIndex = 0;
        }

        return activeTabIndex;
    }

    const loadDataFromUrlParam = async (menu:string, id:string = "", activeTab:number = -1) => {
        var selectedValues:any = {};

        if(menu.toLowerCase() == "hoas" && id) {
            selectedValues = await dashboardService.getHoaById(id, datastore.selectedOrganization?.id);
        }
        else if(menu.toLowerCase() == "municipalities" && id) {
            selectedValues = await dashboardService.getMunicipalityById(id);   
        }
        else if(menu.toLowerCase() === "properties" && id) {
            selectedValues = await dashboardService.getPropertyById(id);
        }
        else if(menu.toLowerCase() === "mails" && id) {
            selectedValues = await dashboardService.getMailById(id);
        }

        if(selectedValues && selectedValues.data) {
            updateSelectedValues(selectedValues.data);
        }

        // change active menu
        if(selectedValues && selectedValues.data &&  selectedValues.data.objectId) {
            changeActiveMenu(menu, true, selectedValues.data.objectId, activeTab);
        }
        else if (menu === 'webhook') {
            changeActiveMenu(menu, true);
        }
        else {
            changeActiveMenu(menu, false);
        }
    }

    const getBillableItemOptions = async (tagType:string) => {
        let billableItemType;
        if(tagType == "Municipality") {
            billableItemType = "Hoa"
        }
        else {
            billableItemType = tagType;
        }

        const response = await dashboardServices.getBillableItems(billableItemType);
        if(response && response.data) {
         if(tagType == "Municipality" || tagType === "Hoa") {
            datastore.billableItemsOptions.municipality=response.data
            datastore.billableItemsOptions.hoa=response.data
         }
         else{
            datastore.billableItemsOptions.property=response.data
         }
        }
    }

    useEffect(()=>{
        UrlParamsService.parseUrlParams();

        datastore.env  = UrlParamsService.urlParams.env;  
        loadAllData()
        .then(() => {
            const menu = getActiveMenu();
            const activeId = UrlParamsService.urlParams.id;
            const activeTab = getActiveTab(menu, activeId);

            loadDataFromUrlParam(menu, activeId, activeTab);
        })
        .catch(() => console.log("error"))


		return () => {}
    },[])

    useEffect(() => {
        if(activeTab == -1) {
            UrlParamsService.updateUrlParam("tab", "");
        }
        else if(activeMenu) {
            let tabTitles = [];
            if(activeMenu == "hoas") {
                tabTitles = config.hoaTabTitles;
            }
            else if(activeMenu == "municipalities") {
                tabTitles = config.municipalityTabTitles;
            }
            else if(activeMenu == "properties") {
                tabTitles = config.propertyTabTitles;
            }
            else if(activeMenu == "webhook") {
                tabTitles = config.webhookTabTitles;
            }
            
            if(activeTab < tabTitles.length) {
                UrlParamsService.updateUrlParam("tab", tabTitles[activeTab].replace(/\s/g, '').toLowerCase());
            }
        }
    }, [activeTab]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const currentId = urlParams.get("id");
        if (!currentId) return;
        const channel = new BroadcastChannel("tab-check");
        channel.postMessage({ id: currentId });
        const handleMessage = (event: any) => {
          if (event.data.id === currentId) {
            alert(`A tab with the same ID: ${currentId} is already open! Close previous tab.`);
            // window.close();
          }
        };
        channel.addEventListener("message", handleMessage);
        return () => {
          channel.removeEventListener("message", handleMessage);
          channel.close();
        };
    }, [selectedValues]);

    const toggleDrawer = () => setState({...state,drawerOpen:!state.drawerOpen})

    const changeActiveMenu = (
        value:string,
        isDetails:boolean = false, 
        activeId:string = "", 
        activeTab:number = -1,
        view:string = ""
    ) => {
        if(!value) {
            return;
        }

        UrlParamsService.updateUrlParam("menu", value.toLowerCase());
        UrlParamsService.updateUrlParam("id", activeId);

        setActiveMenu(value.toLowerCase());

        if(isDetails && activeTab == -1) {
            activeTab = 0;
        }

        if(isDetails) {
            setView(view ? view : 'view-more-details');
        } else {
            setView(view ? view : 'back-to-list');
            setViewMoreDetails({})
        }

        if(value.toLowerCase() === "hoas" && !datastore.billableItemsOptions.hoa.length){
            getBillableItemOptions("Hoa")
        }
        if(value.toLowerCase() === "municipalities" && !datastore.billableItemsOptions.municipality.length){
            getBillableItemOptions("Municipality")
        }
        if(value.toLowerCase() === "properties" && !datastore.billableItemsOptions.property.length){
            getBillableItemOptions("Property")
        }
        if(value.toLowerCase() === "propertiespendingtask" && !datastore.billableItemsOptions.property.length){
            getBillableItemOptions("Property")
        }
        updateActiveTab(activeTab);         
    }

    const updateMuncipalityData = (value:any) =>  setMuncipality(value);
    const updateDataFieldConfigurator = (value: any) => setDataFieldConfigurator(value);
    const updatePropertyData = (value:any) =>setProperty(value);
    const updateHoaData = (value:any) =>  setHoa(value);
    const updateMailData = (value:any) =>  setMail(value);
    const updateEmailData = (value:any) =>  setEmail(value);
    const updateRequestsData = (value:any) => setRequests(value);
    const updateDocumentData = (value:any) => setDocument(value);
    const updateSelectedValues = (value:any) =>  setSelectedValues(value);
    const updateView = (value:string) => setView(value);
    const updateActiveTab = (value:number) => setActiveTab(value);
    const updateSelectedHoaDocuments = (value: any) => setSelectedHoaDocuments(value);
    const updateHoaDocumentToBeDeleted = (value: any) => setHoaDocumentToBeDeleted(value);
    const updateAmenitiesDocImage = (value: any) => setAmenitiesDocImage(value);
    const updateViolationStructureBuildingFiles =(value: any) => setViolationStructureBuildingFiles(value);
    const updateTriggerNotificationData = (value:any) =>  setTriggerNotifications(value);
    const updateTriggerNotificationLogsData = (value:any) => setTriggerNotificationLogs(value);
    const updateSelectedDataFieldConfigurator = (value:any) => setSelectedDataFieldConfigurator(value);
    const updatePendingSource = (value:any) => setPendingSource(value);

    const loadAllData = async () =>{
        const { unauthorized, forbidden } = await checkAccessRights()
        setState({...state,unauthorized:unauthorized,forbidden:forbidden,loadingProgress:90})

        if( unauthorized || forbidden) return;

        const { role } =  await checkUserRole();
        datastore.userRole = role;

        await getUserDataInformation();

        if(role === config.userRoles.OrganizationUser) {
            const {organizations} = await checkWhichOrgUser(datastore.ownerInformation.id);
            datastore.organizations = organizations;

            if(organizations.length === 0) {
                return window.alert('You dont have any organization.')
            }

            if(organizations && organizations.length === 1){
                datastore.selectedOrganization = organizations[0];
                setState({...state, selectedOrganization: organizations})
                const { data } = await dashboardServices.getDataFieldConfiguratorByOrganizationId(datastore.selectedOrganization.id);
                    if(data?.hoaConfig && data?.hoaConfig?.fieldData){
                        datastore.selectedConfiguration = data.hoaConfig.fieldData;
                        mappingNotVisibleKeys(data.hoaConfig.fieldData);
                        updateSelectedDataFieldConfigurator(data.hoaConfig.fieldData)
                    }
                }
            }

        setState({...state,loadingProgress:100})
    }


    const login = (
        (state.unauthorized &&
            <Login
                key='unauthorized-access'
                dark={false}
                unauthorized={state.unauthorized}
                header='Unauthorized access'
                text='Please make sure you are signed in and have access to this tool.'
            />) ||
        (state.forbidden &&
            <Login
                key='forbidden-access'
                dark={false}
                forbidden={state.forbidden}
                header='Access denied'
                text='You either do not have access to this tool, or it does not exist.'
            />)
    );


    if(state.error) return <ErrorMessage errorHeader='ERROR' errorText={state.error} />

    if (login) return login;

    if(datastore.userRole === config.userRoles.OrganizationUser && !datastore.selectedOrganization?.id) {
        return (
            <OrganizationSelection state={state} setState={setState} updateSelectedDataFieldConfigurator={updateSelectedDataFieldConfigurator}/>
        )
    }

    if(state.loadingProgress < 100){
        return(
            <>
                <SplashPhoto key='splash-photo' />
                <Loading
                    key='loading-progress'
                    loadingProgress={state.loadingProgress}
                    loadingMessage='Loading Data'
                />
            </>
        )
    }

    let globalValue = {
        open:state.drawerOpen,
        toggleDrawer,
        activeMenu:activeMenu,
        changeActiveMenu:changeActiveMenu,
        activeTab,
        updateActiveTab,
        muncipality,
        updateMuncipalityData,
        property,
        updatePropertyData,
        hoa,
        updateHoaData,
        mail,
        updateMailData,
        email,
        updateEmailData,
        requests,
        updateRequestsData,
        document,
        updateDocumentData,
        selectedValues,
        updateSelectedValues,
        view,
        updateView,
        viewMoreDetails,
        setViewMoreDetails,
        selectedHoaDocuments,
        updateSelectedHoaDocuments,
        hoaDocumentToBeDeleted,
        updateHoaDocumentToBeDeleted,
        amenitiesDocImage,
        updateAmenitiesDocImage,
        violationStructureBuildingFiles,
        updateViolationStructureBuildingFiles,
        triggerNotifications,
        updateTriggerNotificationData,
        triggerNotificationLogs,
        updateTriggerNotificationLogsData,
        dataFieldConfigurator,
        updateDataFieldConfigurator,
        selectedDataFieldConfigurator,
        updateSelectedDataFieldConfigurator,
        pendingSource,
        updatePendingSource
    }

    return (
        <GlobalContext.Provider value={globalValue}>
            <Layout />
        </GlobalContext.Provider>
    )

}